import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const JobsViewodal = ({ show, handleClose, isEdit }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose} size='lg'>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">Job Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Render row details */}
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Driver Name:</span>
                            <p>{isEdit?.driver?.full_name || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Job Date:</span>
                            <p>{isEdit?.job_date || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Job Time:</span>
                            <p>{isEdit?.job_time || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>C-Number:</span>
                            <p>{isEdit?.c_number || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Miles:</span>
                            <p>{isEdit?.miles || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Hourly Rate:</span>
                            <p>{isEdit?.hourly_rate || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Job Amount:</span>
                            <p>{isEdit?.job_amount || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Created Date:</span>
                            <p>{isEdit?.created_at || '-'}</p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* <JobsEditModal
                show={isEdit}
                handleClose={() => setIsEdit(false)}
            /> */}
        </>
    );
};

export default JobsViewodal;